// ADDED: Specialized Hook for the Approver Inbox
import { useState, useCallback, useEffect } from "react";
import salaryAdvanceService from "../services/salaryAdvanceService";

export const useSalaryAdvanceApprovals = (user) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({ vesselId: null, status: "All" });

  const [alertProps, setAlertProps] = useState({ showMessage: false, message: "", isSuccess: false });

  const fetchData = useCallback(async () => {
    if (!user?.employeePersonalInformationId) return;
    setLoading(true);
    try {
      const approverId = user.employeePersonalInformationId;
      const apiFilters = {
        status: filters.status !== "All" ? filters.status : undefined,
        vesselId: filters.vesselId || undefined
      };
      const res = await salaryAdvanceService.getRequestsForApprover(approverId, apiFilters);
      setData(res);
      setFilteredData(res);
    } catch (err) { console.error("v2: Approval Fetch Error", err); }
    finally { setLoading(false); }
  }, [user, filters]);

  useEffect(() => { fetchData(); }, [fetchData]);

  useEffect(() => {
    if (!searchTerm) { setFilteredData(data); return; }
    const low = searchTerm.toLowerCase();
    setFilteredData(data.filter(i =>
      i.referenceNumber?.toLowerCase().includes(low) ||
      i.employeeFullName?.toLowerCase().includes(low)
    ));
  }, [searchTerm, data]);

  const handleAction = async (id, type, remarks = "") => {
    setLoading(true);
    try {
      const approverId = user.employeePersonalInformationId;
      if (type === "approve") await salaryAdvanceService.approveRequest(id, approverId, remarks);
      else await salaryAdvanceService.disapproveRequest(id, approverId, remarks);

      setAlertProps({ showMessage: true, message: `Action successful`, isSuccess: true });
      await fetchData();
      return { success: true };
    } catch (err) {
      setAlertProps({ showMessage: true, message: `Action failed`, isSuccess: false });
      return { success: false, err };
    } finally { setLoading(false); }
  };

  const updateApprovedAmount = async (id, approvedAmount, reason) => {
    setLoading(true);
    try {
      const payload = {
        approvedAmount: parseFloat(approvedAmount),
        approvedAmountReason: reason
      };
      await salaryAdvanceService.updateApprovedAmount(id, payload);
      setAlertProps({ showMessage: true, message: "Approved amount updated successfully", isSuccess: true });
      await fetchData(); // Refresh list to see changes
      return { success: true };
    } catch (err) {
      setAlertProps({ showMessage: true, message: "Failed to update amount", isSuccess: false });
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const updateSalaryAdvanceType = async (id, type) => {
    setLoading(true);
    try {
      const payload = {
        salaryAdvanceType: type,
      };
      console.log({payload})
      await salaryAdvanceService.updateSalaryAdvanceType(id, payload);
      setAlertProps({ showMessage: true, message: "Salary Advance Type updated successfully", isSuccess: true });
      await fetchData(); // Refresh list to see changes
      return { success: true };
    } catch (err) {
      setAlertProps({ showMessage: true, message: "Failed to update Salary Advance Type", isSuccess: false });
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    data: filteredData,
    filters,
    setFilters,
    searchTerm,
    setSearchTerm,
    handleAction,
    updateApprovedAmount,
    updateSalaryAdvanceType,
    alertProps
  };
};